import { render, staticRenderFns } from "./productHospitalPrice.vue?vue&type=template&id=3110a342"
import script from "./productHospitalPrice.vue?vue&type=script&lang=js"
export * from "./productHospitalPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports